<template>
  <layout>
    <section>
      <div class="row">
        <div class="col-md-12">
          <div class="card mt-n2">
            <div class="card-body">
              <div v-if="showPreviewCards && !loading">
                <preview-box-cards></preview-box-cards>
              </div>
              <div v-else>
                <div class="text-right mt-n5 pt-0 pb-5 pr-2 pr-xl-5">
                  <choose-report-period />
                </div>
                <box-filters-and-sorting v-model="eventsRetrieveParams"></box-filters-and-sorting>
                <loader v-if="loading"></loader>
                <div v-if="!loading" class="row project-list-showcase">
                  <smart-oee-box-card
                    v-for="box in items"
                    :key="box.deviceId"
                    :box="box"
                    :efficiency="getOee(box)"
                    :imageBox="getImage(box)"
                  ></smart-oee-box-card>
                  <p v-if="isEmptyItemsByFilters" class="m-auto text-muted">
                    {{ $t('boxes.noBoxes') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import boxesQuery from '@/api/boxCards/boxes.gql';
import boxesImage from '@/api/boxCards/boxImages.gql';
import demoBoxesQuery from '@/api/boxCards/demoBoxes.gql';
import todayEfficiencys from '@/api/boxCards/todayEfficiency.gql';
import defaultImage from '@/assets/images/KOEEBOX.png';

import { mapGetters } from 'vuex';

export default {
  name: 'SmartOeeBoxes',
  components: {
    PreviewBoxCards: () => import('@/components/boxes/PreviewBoxCards'),
    BoxFiltersAndSorting: () => import('@/components/boxes/box/BoxFiltersAndSorting'),
    SmartOeeBoxCard: () => import('@/components/boxes/box/BoxCard'),
    ChooseReportPeriod: () => import('@/components/report/ChooseReportPeriod'),
  },
  data() {
    return {
      defaultImage,
      isItemsFilters: false,
      eventsRetrieveParams: {
        filters: {
          equipment: '',
          efficiency: [],
          models: [],
        },
        sorted: {
          sortedByName: 'NONE',
        },
      },
    };
  },
  computed: {
    ...mapGetters(['isPreview']),
    workCenterIds() {
      return this.boxes
        ? this.boxes.map((b) => ((b.digitalThing || {}).workCenter || {}).id).filter((i) => !!i)
        : [];
    },
    loading() {
      return this.$apollo.queries.boxes.loading;
    },
    items() {
      return this.boxes || this.demoBoxes || [];
    },
    isDemo() {
      return this.$store.getters.isDemo;
    },
    showPreviewCards() {
      return (this.isDemo || this.items.length === 0) && !this.isPreview && !this.isItemsFilters;
    },
    isEmptyItemsByFilters() {
      return this.isItemsFilters && this.items.length === 0;
    },
  },
  watch: {
    eventsRetrieveParams() {
      this.isItemsFilters = true;
    },
  },
  methods: {
    getOee(box) {
      const workCenterId = this.getWorkCenterId(box);

      return this.todayEfficiencys && workCenterId && this.todayEfficiencys[workCenterId]
        ? this.todayEfficiencys[workCenterId].oee
        : 0.1;
    },
    getImage(box) {
      const workCenterId = this.getWorkCenterId(box);

      return this.boxImages && workCenterId && this.boxImages[workCenterId]
        ? this.boxImages[workCenterId].digitalThing.workCenter.attachmentImage
        : null;
    },
    getWorkCenterId(box) {
      return ((box.digitalThing || {}).workCenter || {}).id;
    },
  },
  apollo: {
    boxes: {
      query: boxesQuery,
      variables() {
        return {
          retrieveParams: {
            effectiveTypes: this.eventsRetrieveParams.filters.efficiency,
            filter: this.eventsRetrieveParams.filters.equipment,
            models: this.eventsRetrieveParams.filters.models,
          },
          orderByParams: {
            name: this.eventsRetrieveParams.sorted.sortedByName,
          },
        };
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.boxes && queryData.boxes.length) {
          return queryData.boxes;
        } else {
          return null;
        }
      },
      skip() {
        return this.isDemo || this.isPreview;
      },
      error(e) {
        console.log(e);
      },
    },
    demoBoxes: {
      query: demoBoxesQuery,
      deep: true,
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.demoBoxes && queryData.demoBoxes.length) {
          return queryData.demoBoxes;
        } else {
          return null;
        }
      },
      skip() {
        return !this.isDemo && !this.isPreview;
      },
      error() {
        this.$router.push({ name: 'MaintenanceOee' });
      },
    },
    todayEfficiencys: {
      query: todayEfficiencys,
      variables() {
        return {
          workCenterIds: this.workCenterIds,
        };
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        let boxEfficiency = {};
        if (queryData && queryData.todayEfficiency) {
          boxEfficiency = queryData.todayEfficiency.reduce((values, efficiency) => {
            values[efficiency.workCenterId] = efficiency;
            return values;
          }, {});
        }

        return boxEfficiency;
      },
      skip() {
        return !this.workCenterIds;
      },
    },
    boxImages: {
      query: boxesImage,
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        let imagesBox = {};
        if (queryData && queryData.boxes) {
          imagesBox = queryData.boxes.reduce((values, image) => {
            values[image.digitalThing.workCenter.id] = image;
            return values;
          }, {});
        }
        return imagesBox;
      },
    },
  },
};
</script>
